<template>
  <div class="container">
    <div>
      <el-tabs v-model="activeName" @tab-click="tabChange">
        <el-tab-pane label="门店员工" name="storeStaff">
          <storeStaff :visible="activeName === 'storeStaff'" />
        </el-tab-pane>
        <el-tab-pane label="身份设置" name="identitySettings">
          <identitySettings
            :visible="activeName === 'identitySettings'"
            :types="types"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import identitySettings from "../identitySettings/index.vue";
import storeStaff from "../storeStaff/index.vue";
import { PageModule } from "@/store/module/page";
export default {
  components: { identitySettings, storeStaff },
  data() {
    return {
      activeName: "storeStaff",
      types: "",
    };
  },
  created() {
    const _t = this;
    if (PageModule.latestRoute === "dashboard") {
      // 来自首页
      _t.activeName = this.$route.params.tab || "storeStaff";
    } else {
      if (_t.$route.query.type) {
        _t.activeName = "identitySettings";
        _t.types = _t.$route.query.type;
      } else {
        let pageCache = sessionStorage.getItem(
          "store-employee-manage-page-cache"
        );
        if (pageCache) {
          let pageCacheJSON = JSON.parse(pageCache);
          if (pageCacheJSON.tab) {
            this.activeName = pageCacheJSON.tab;
          }
        }
      }
    }
  },
  methods: {
    tabChange(v) {
      sessionStorage.setItem(
        "store-employee-manage-page-cache",
        JSON.stringify({
          tab: this.activeName,
        })
      );
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  position: relative;
  height: calc(100% - 34px);
  background: #fff;
  overflow-y: auto;
}
.el-tabs__item.is-top.is-active {
  color: #07d1aa !important;
}
</style>
